"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const template_parser_1 = require("@osmosys/template-parser");
const utils_1 = require("@osmosys/utils");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const graphql_1 = require("../../graphql");
const runStepsOnRootElement_1 = require("./runStepsOnRootElement");
const react_hooks_1 = require("@apollo/react-hooks");
const react_hanger_1 = require("react-hanger");
const react_use_1 = require("react-use");
const OsmosysLogTerminal_1 = require("../OsmosysLogTerminal");
const useLogsReducer_1 = require("../OsmosysLogTerminal/useLogsReducer");
exports.OsmosysConverterInner = props => {
    const { contentStr, onChange, onClose, steps, run, linkToPost, showSpinner, } = props;
    const client = react_hooks_1.useApolloClient();
    const isMounted = react_1.useRef(true);
    const [logs, dispatch] = useLogsReducer_1.useLogsReducer([]);
    const [status, setStatus] = react_1.useState(run ? 'loading' : 'notRunning');
    const hasSucceeded = status === 'success';
    // const prevHasSucceeded = usePrevious(hasSucceeded);
    const isLoading = status === 'loading';
    const prevIsLoading = react_hanger_1.usePrevious(isLoading);
    const hasErrored = status === 'error';
    const prevHasErrored = react_hanger_1.usePrevious(hasErrored);
    //   let content = contentStr || '';
    //   if (contentFeed && contentItem && contentFieldKey) {
    //     content = contentItem[contentFieldKey].data;
    //   }
    react_1.useEffect(() => {
        if (status === 'notRunning' && run) {
            setStatus('loading');
        }
    }, [run, status]);
    react_1.useEffect(() => {
        if (isLoading && !prevIsLoading && props.onStart) {
            props.onStart();
        }
    }, [prevIsLoading === isLoading]);
    // useEffect(() => {
    //   if (hasSucceeded && !prevHasSucceeded && props.onSuccess) {
    //   }
    // }, [hasSucceeded === prevHasSucceeded]);
    react_1.useEffect(() => {
        if (hasErrored && !prevHasErrored && props.onError) {
            props.onError();
        }
    }, [hasErrored === prevHasErrored]);
    let el = template_parser_1.stringToEl(contentStr).content;
    const checkIfMounted = react_1.useCallback(() => {
        return true;
    }, [isMounted && isMounted.current]);
    const log = (level, opts) => {
        dispatch({
            log: Object.assign({ level }, opts),
            type: 'add',
        });
    };
    react_use_1.useDeepCompareEffect(() => {
        isMounted.current = true;
        // eslint-disable-next-line no-async-promise-executor
        new Promise(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (!run) {
                if (status !== 'notRunning') {
                    setStatus('notRunning');
                }
                return;
            }
            if (status !== 'notRunning') {
                log('debug', {
                    message: 'Running new conversion...',
                });
            }
            if (linkToPost) {
                log('debug', {
                    message: `Has link to content item: ${linkToPost}`,
                });
            }
            if (!contentStr) {
                log('error', {
                    message: 'No content found. Exiting...',
                });
                setStatus('error');
                return;
            }
            if (steps.length === 0) {
                log('debug', {
                    message: 'This conversion has no more steps to take. Stopping...',
                });
                setStatus('notRunning');
                return;
            }
            log('info', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Converting (",
                    steps.length,
                    " step",
                    steps.length === 1 ? '' : 's',
                    ")...")),
                plainTextMessage: `Converting (${steps.length} step${steps.length === 1 ? '' : 's'})...`,
                previewHtml: contentStr,
            });
            el = yield runStepsOnRootElement_1.runStepsOnRootElement({
                checkIfMounted,
                client: client,
                contentStr,
                createScreenshot: (html, step) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    const resp = yield client.mutate({
                        mutation: graphql_1.createScreenshot,
                        variables: {
                            options: {
                                headHtml: step.headHtml,
                                html,
                                includedHtml: step.includedHtml,
                                renderTimeout: 2 * 1000,
                            },
                        },
                    });
                    return resp.data.createScreenshot.url;
                }),
                dispatch,
                el,
                linkToPost,
                log,
                onChange: () => {
                    // if (checkIfMounted()) {
                    //   logger.info(
                    //     'OsmosysConverterInner | runSteps.onChange | Updating contentStr'
                    //   );
                    //   if (el) {
                    //     onChange(elToHtmlString(el));
                    //     // {
                    //     //     //     ...block,
                    //     //     // contentFeed: null,
                    //     //     // contentFieldKey: null,
                    //     //     // contentItem: null,
                    //     //     // contentSlotNumber: null,
                    //     //     // conversions: true,
                    //     //     // conversions: true,
                    //     //     contentStr: ,
                    //     // });
                    //   }
                    // } else {
                    //   logger.warn(
                    //     'OsmosysConverterInner | runSteps.onChange | Doing nothing, because of an unmount'
                    //   );
                    // }
                },
                steps,
            });
            //   await new Promise(bufferResolver =>
            //     setTimeout(() => {
            //       bufferResolver();
            //     }, 100)
            //   );
            if (!checkIfMounted()) {
                utils_1.logger.warn('OsmosysConverterInner | runSteps.onChange | Exiting because of an unmount');
                setStatus('notRunning');
                if (props.onStop) {
                    props.onStop();
                }
                return;
            }
            if (!el) {
                log('error', {
                    message: 'Conversion failed.',
                });
                setStatus('error');
            }
            const newHtml = template_parser_1.elToHtmlString(el);
            if (newHtml) {
                log('success', {
                    message: react_1.default.createElement(react_1.default.Fragment, null, "\u2705 Conversion completed."),
                    plainTextMessage: 'Conversion completed.',
                    previewHtml: newHtml,
                });
            }
            else {
                log('success', {
                    message: react_1.default.createElement(react_1.default.Fragment, null, "\u2705 Conversion completed, but had an output of no HTML."),
                    plainTextMessage: 'Conversion completed, but had an output of no HTML',
                    previewHtml: newHtml,
                });
            }
            props.onSuccess(newHtml);
        }));
        return () => {
            isMounted.current = false;
        };
    }, [run, steps]);
    const showBottomToolbar = false;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OsmosysLogTerminal_1.OsmosysLogTerminal, { showSpinner: showSpinner, onClose: onClose, logs: logs, status: status, run: run }),
        showBottomToolbar && (react_1.default.createElement("div", { className: "p-2 border-top d-flex flex-row" },
            react_1.default.createElement("div", { className: "flex-grow-1" }, status === 'loading' && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSpinnerThird, spin: true }))),
            react_1.default.createElement("div", { className: "flex-grow-0 flex-col-centered w-100" },
                react_1.default.createElement(reactstrap_1.Button, { color: "light", onClick: onClose }, "Close"))))));
};
//# sourceMappingURL=Inner.js.map